// extracted by mini-css-extract-plugin
export default {"containerPesquisa":"Processos_containerPesquisa__0CyFs","cardsContainer":"Processos_cardsContainer__TB3-A","spinner":"Processos_spinner__GHRrZ"};